import { useRef } from 'react';
import { useParams } from 'react-router';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import NoteItemInput from './NoteItemInput';
import { useWhatIf } from '../component/WhatIfProvider';
import NoteItemList from './NoteItemList';

function NoteItemOperator() {
	const { id } = useParams('id');
	const { figure, showPropertiesDialog, setShowPropertiesDialog } = useWhatIf();
	const { t } = useTranslation('whatIf');
	const item = figure.note.find(d => d.key === showPropertiesDialog.key);
	const updateListRef = useRef(null);
	const whatIfId = id === 'new' ? null : Number.parseInt(id, 10);
	const notesAvailable = Number.isInteger(whatIfId);

	return (
		<Dialog open maxWidth="lg" fullWidth>
			<DialogTitle disableTypography className="border-b">
				<div className="flex flex-row w-full">
					<div className="flex mr-24 items-center">{item.name}</div>
				</div>
			</DialogTitle>
			<DialogContent className="p-20" style={{ height: 'calc(100vh - 300px)' }}>
				<div className="h-full flex flex-col">
					{notesAvailable ? (
						<>
							<NoteItemList whatIf={whatIfId} noteItemKey={item.key} updateListRef={updateListRef} />
							<NoteItemInput whatIf={whatIfId} noteItemKey={item.key} onChange={() => (updateListRef.current != null ? updateListRef.current() : null)} />
						</>
					) : (
						<div className="h-full flex items-center justify-center text-stone-400">{t('notesSaveWhatIfFirst')}</div>
					)}
				</div>
			</DialogContent>
			<DialogActions className="justify-between border-t p-20">
				<Button onClick={() => setShowPropertiesDialog(null)}>{t('close')}</Button>
			</DialogActions>
		</Dialog>
	);
}

export default NoteItemOperator;
